export default __webpack_public_path__ + "static/media/q28_step3.17d4ddea.png";